
import { Component, Prop, Vue } from 'vue-property-decorator';
import config from '@/config';
import SvgPopup from '@/components/Svg/SvgPopup.vue';

@Component({
  components: {
    SvgPopup,
  },
})
export default class NeedToFederateDialog extends Vue {
  @Prop({
    type: Object,
    required: false,
  })
  readonly userInfos!: any;

  federationLink = config.federateLink;

  snackbar = false;

  snackbarMessage = '';

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.xsOnly;
  }

  showSnackBar(message: string) {
    this.snackbarMessage = message;
    this.snackbar = true;
  }

  async handleAcceptfederate() {
      // open browser with federation tisseo link
  }

}
